/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";
import StockTransferCrud from "./StockTransferCrud";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function StockTransferList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 162) / 33)
  );

  useEffect(() => {
    loadData(props.stockTransferType == "OUT" ? "DRAFT" : "QUEUED");
  }, []);

  function onEditClicked(row, updateValue, value, type) {
    biRef.outgoing.showWindow(row.tableData[row.rowIndex].id, type, false);
  }

  async function loadData(status) {
    let sort = '[{id:"orderId",sortOrder:"DESC"}]';
    let search = "[]";
    if (status) {
      let str = "[";
      str +=
        '{id:"transferType",value:' +
        (props.stockTransferType == "OUT" ? '"OUT"' : '"IN"') +
        ',regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"},';
      str +=
        '{id:"status",value:"' +
        status +
        '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}';

      str += "]";
      search = str;
    }
    loadByRest(0, rowLimitPerPage, sort, search);
    //loaadByDB();
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/inventorytransfer/list?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data.data);
    setIsLoading(false);
  }

  async function onTableChange(tableState) {
    console.log(tableState);
    let sort = '[{id:"date",sortOrder:"DESC"}]';

    let search = "[";
    search +=
      '{id:"status",value:"' +
      (tableState.filterList[3][0] ? tableState.filterList[3][0] : "DRAFT") +
      '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"},';
    search +=
      '{id:"transferType",value:"' +
      props.stockTransferType +
      '"' +
      ',regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}';
    if (tableState.searchText) {
      search +=
        ',{id:"orderId",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
    }
    search += "]";
    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  const options = {
    download: false,
    searchPlaceholder: "Search by Invoice Number",
    serverSide: true,
    searchable: true,
    viewColumns: false,
    filter: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Refresh Data"}>
            <IconButton
              size="small"
              color="primary"
              onClick={purchaseorderListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          {props.stockTransferType == "OUT" && (
            <Tooltip title={"Add Outgoing"}>
              <IconButton size="small" color="primary" onClick={onaddData}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "orderId",
      label: translate("Order Id"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "date",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formatDate(new Date(value), 1);
        },
      },
    },
    {
      name: props.stockTransferType == "OUT" ? "targetShopCode" : "fromShop",
      label:
        props.stockTransferType == "OUT"
          ? translate("Target Shop")
          : translate("From Shop"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "status",
      label: translate("Status"),
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          names: ["QUEUED", "POSTED"],
        },
      },
    },
    {
      name: "amount",
      label: translate(" Amount"),
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return StringUtils.formattedNumber(
            value,
            props.context.store.currencyDecimal
          );
        },
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            {tableMeta.tableData[tableMeta.rowIndex].status == "QUEUED" && (
              <Button
                onClick={() =>
                  onEditClicked(tableMeta, updateValue, value, "Edit")
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("Open")}
              </Button>
            )}
            {tableMeta.tableData[tableMeta.rowIndex].status == "DRAFT" && (
              <Button
                onClick={() =>
                  onEditClicked(tableMeta, updateValue, value, "Edit")
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("Edit")}
              </Button>
            )}
            {tableMeta.tableData[tableMeta.rowIndex].status == "POSTED" && (
              <Button
                onClick={() =>
                  onEditClicked(tableMeta, updateValue, value, "Edit")
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("View")}
              </Button>
            )}
          </div>
        ),
      },
    },
  ];

  function purchaseorderListRefresh() {
    loadData("DRAFT");
  }

  function onaddData() {
    biRef.outgoing.showWindow();
  }

  var biRef = {};

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <div>
            <MUIDataTable
              title={
                <Typography variant="h6">
                  {props.stockTransferType == "OUT"
                    ? translate("Outgoing Stock")
                    : translate("Incoming Stock")}
                  {isLoading && (
                    <CircularProgress
                      size={24}
                      style={{ marginLeft: 15, position: "relative", top: 4 }}
                    />
                  )}
                </Typography>
              }
              data={data}
              columns={columns}
              options={option}
            />
          </div>
        </Grid>
      </Grid>
      <StockTransferCrud
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
        productCache={props.productCache}
        stockTransferType={props.stockTransferType}
        refreshList={purchaseorderListRefresh}
      ></StockTransferCrud>
    </>
  );
}
